/* ==========================================================
   Texto animado dentro de la barra de busqueda.

   PREFIX se queda siempre fijo y solo se escribe/borra lo que
   sigue, para que el campo nunca se vea vacio.

   PARA CAMBIAR EL TEXTO: edita PREFIX y la lista PHRASES.
   Para desactivarlo: quita la linea que carga este archivo
   en layout/theme.liquid.
   ========================================================== */
(function () {
  var PREFIX = 'Busca ';

  var PHRASES = [
    'cajas organizadoras',
    'coolers y termos',
    'productos de limpieza'
  ];

  var TYPE_MS = 70; // velocidad al escribir
  var ERASE_MS = 25; // velocidad al borrar
  var HOLD_MS = 2000; // pausa con la frase completa
  var PAUSE_MS = 300; // pausa antes de la siguiente frase

  if (!PHRASES.length) return;

  // Si el visitante pidio menos animaciones, se deja el texto original.
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  var inputs = [];
  var original = '';
  var phraseIndex = 0;
  var charIndex = 0;
  var erasing = false;
  var timer = null;
  var paused = false;

  function setPlaceholder(text) {
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].setAttribute('placeholder', text);
    }
  }

  function paint() {
    setPlaceholder(PREFIX + PHRASES[phraseIndex].slice(0, charIndex));
  }

  function step() {
    if (paused) return;

    var phrase = PHRASES[phraseIndex];

    if (!erasing) {
      charIndex++;
      paint();
      if (charIndex >= phrase.length) {
        erasing = true;
        timer = window.setTimeout(step, HOLD_MS);
        return;
      }
      timer = window.setTimeout(step, TYPE_MS);
      return;
    }

    charIndex--;
    paint();
    if (charIndex <= 0) {
      erasing = false;
      phraseIndex = (phraseIndex + 1) % PHRASES.length;
      timer = window.setTimeout(step, PAUSE_MS);
      return;
    }
    timer = window.setTimeout(step, ERASE_MS);
  }

  function pause() {
    paused = true;
    window.clearTimeout(timer);
    setPlaceholder(original);
  }

  function resume() {
    // Solo se reanuda si el campo esta vacio y sin foco
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i] === document.activeElement || inputs[i].value) return;
    }
    if (!paused) return;
    paused = false;
    charIndex = 0;
    erasing = false;
    step();
  }

  function collect() {
    var found = document.querySelectorAll('input[name="q"]');
    inputs = [];
    for (var i = 0; i < found.length; i++) {
      inputs.push(found[i]);
      if (!found[i].dataset.animatedPlaceholder) {
        found[i].dataset.animatedPlaceholder = 'true';
        found[i].addEventListener('focus', pause);
        found[i].addEventListener('blur', resume);
      }
    }
  }

  function init() {
    collect();
    if (!inputs.length) return;
    original = inputs[0].getAttribute('placeholder') || '';
    step();

    // El encabezado puede volver a dibujarse (menu movil, editor de temas)
    new MutationObserver(function () {
      var before = inputs.length;
      collect();
      if (inputs.length !== before && !paused) paint();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(collect, 50);
  });
})();